import { Star } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Showed up early, walked the property, and texted the quote on the spot. The driveway looks like it was poured last week.",
    author: "Maya R.",
    location: "Silverleaf",
    service: "Driveway Restoration",
  },
  {
    quote:
      "We’ve hired three companies over the years. Sonoran is the only one I’ll call again. Quiet, careful, and genuinely thorough.",
    author: "Daniel C.",
    location: "Paradise Valley",
    service: "House + Patio Wash",
  },
  {
    quote:
      "They treat a residential job like a portfolio piece. The before/after on our pavers honestly stopped me mid-step.",
    author: "Renée O.",
    location: "DC Ranch",
    service: "Patio · Travertine",
  },
];

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative bg-[#0a0a0c] py-24 sm:py-32 lg:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
          <div className="lg:col-span-7">
            <p className="font-mono-small text-[#E5D0A1] mb-6">— Word of Mouth</p>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] leading-[1.02]">
              The work speaks.
              <br />
              <span className="font-editorial italic text-white/60 font-normal">
                Our neighbors do the rest.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-center gap-6">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-5 h-5 fill-[#E5D0A1] text-[#E5D0A1]"
                  strokeWidth={1}
                />
              ))}
            </div>
            <div>
              <p className="font-display text-white text-2xl tracking-tight">
                4.97 / 5.00
              </p>
              <p className="font-mono-small text-white/40 mt-1">
                380+ verified reviews
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0d0d10] p-8 sm:p-10 flex flex-col"
            >
              <div className="flex gap-1 mb-8">
                {[...Array(5)].map((_, k) => (
                  <Star
                    key={k}
                    className="w-3.5 h-3.5 fill-[#E5D0A1] text-[#E5D0A1]"
                    strokeWidth={1}
                  />
                ))}
              </div>
              <p
                className="font-editorial text-white text-2xl sm:text-[26px] leading-snug tracking-tight flex-1"
              >
                “{r.quote}”
              </p>
              <div className="mt-10 pt-6 border-t border-white/10 flex items-center justify-between">
                <div>
                  <p className="font-medium text-white">{r.author}</p>
                  <p className="font-mono-small text-white/40 mt-1">
                    {r.location}
                  </p>
                </div>
                <p className="font-mono-small text-[#E5D0A1]">{r.service}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
